import React from "react";
import { Check } from "lucide-react";

export default function PlanFeatureGroups({
  features,
  className = "",
  emptyMessage = "No included features are listed for this plan.",
}) {
  const items = features ?? [];

  if (!items.length) {
    return <p className="text-sm text-textSecondary">{emptyMessage}</p>;
  }

  return (
    <ul className={`space-y-2 ${className}`}>
      {items.map((feature) => (
        <li
          key={feature.code || feature.name}
          className="flex items-start gap-2 text-[12px] leading-snug text-textSecondary"
        >
          <Check className="mt-0.5 h-3 w-3 flex-shrink-0 text-primary" />
          <span className="min-w-0 flex-1 break-words">
            {feature.name}
            {feature.limitLabel && (
              <span className="ml-2 inline-flex rounded-full bg-primary/10 px-1.5 py-0.5 text-[10px] font-medium leading-none text-primary">
                {feature.limitLabel}
              </span>
            )}
          </span>
        </li>
      ))}
    </ul>
  );
}